<template>
  <form
    class="flex flex-wrap items-center justify-between rounded border border-background-fg/8 p-2"
    @submit="onSubmit"
  >
    <FormInputPercentage
      name="defaultServiceChargePercentage"
      label="Default Percentage Service Charge"
    />
    <FormInputPrice
      name="defaultServiceChargeFlat"
      label="Default Flat Service Charge"
      :min="0"
    />
    <FormSubmitButton> Save </FormSubmitButton>
    <BaseInnerLoading v-if="isSubmitting" />
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import z from "zod"
import { toTypedSchema } from "@vee-validate/zod"

type ServiceChargeForm = {
  defaultServiceChargeFlat: number
  defaultServiceChargePercentage: number
}
const props = defineProps<{
  initialValues: ServiceChargeForm
}>()

const { setTenantState } = useTenant()

const serviceChargeFormSchema = z.object({
  defaultServiceChargePercentage: z
    .number()
    .min(0)
    .max(100),
  defaultServiceChargeFlat: z.number().min(0),
})
const { handleSubmit, resetForm, isSubmitting } = useForm({
  validationSchema: toTypedSchema(serviceChargeFormSchema),
  initialValues: {
    defaultServiceChargePercentage: 0,
    defaultServiceChargeFlat: 0,
  },
})

watch(
  () => props.initialValues,
  async (values) => {
    resetForm({ values: values })
  },
  {
    deep: true,
    immediate: true,
  }
)

const onSubmit = handleSubmit(async (params) => {
  try {
    const newTenantState =
      await partialUpdateSettings(params)
    setTenantState(newTenantState)
    toast.success("Service Charge settings updated")
  } catch {
    toast.error("Failed to update Service Charge settings")
  }
})
</script>
